import { useEffect } from 'react';
import Link from 'src/components/Common/Link';
import { ResolvedContent } from '..';
import { ButtonGroup } from '../../../Common/@electron/ButtonGroup';
import { FormsMessage } from '../../../Common/@electron/FormsMessage';
import { sendCalNoReturnCode, sendVpv } from '../analytics';

type ErrorProps = {
  error?: ResolvedContent['returnCodes'][number]['fields'];
  returnCode: string;
  endpoint: string;
};

export const ErrorView = ({ error, returnCode, endpoint }: ErrorProps) => {
  const title = error?.Title.value;
  const message = error?.Message.value;
  const primaryBtn = error?.['Primary CTA Link']?.value;
  const secondaryBtn = error?.['Secondary CTA Link']?.value;
  const variant = error?.Variant.value || 'info';

  // Replace fallback 'E' with 'no-return-code' at request of analytics dept
  const returnCodeIsDefault = returnCode === 'E';
  const returnCodeForVPV = returnCodeIsDefault ? 'no-return-code' : returnCode;

  useEffect(() => {
    if (error) {
      sendVpv('error', undefined, returnCodeForVPV);
      sendCalNoReturnCode(
        'account-selector_error',
        `${returnCode}-|-${title}-|-${endpoint}`,
        'list-of-accounts'
      );
    }
  }, [error, returnCode, message]);

  return (
    <div role="alert" aria-live="polite" aria-atomic="true">
      <FormsMessage variant={variant} title={title} description={message}>
        <ButtonGroup
          primary={
            primaryBtn?.href ? (
              <Link
                value={{ ...primaryBtn, text: error?.['Primary CTA Label']?.value }}
                className="btn btn-primary btn-md btn-auto"
              />
            ) : undefined
          }
          secondary={
            secondaryBtn?.href ? (
              <Link
                value={{ ...secondaryBtn, text: error?.['Secondary CTA Label']?.value }}
                className="btn btn-secondary btn-md btn-auto"
              />
            ) : undefined
          }
        />
      </FormsMessage>
    </div>
  );
};
